import classNames from 'classnames'

import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

import countriesEn from '~/const/countries-en.json'

const countriesTranslations: Record<string, string> = countriesEn

import './style.scss'

const LargeFlagCellRenderer = ({ value }: ICellRendererParams<unknown, string>): ReactElement => {
  if (!value) return <div />

  const flagClasses = classNames('flag fi', { [`fi-${value.toLowerCase()}`]: true })

  return (
    <div className="flag-component-wrapper">
      <span className={flagClasses} />
      <div className="details-container">
        <div className="country">{countriesTranslations[value] || value}</div>
        <div className="locale">{value}</div>
      </div>
    </div>
  )
}

export default LargeFlagCellRenderer
